import { TIMEOUT, apiAriannaGW, apiAriannaTS } from "../../api/api";
import { generateHeadersCfTns } from "../../auth/authFunctions";
import { ERRORE_CHECK_SCREENING, ERRORE_GENERICO_API, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED } from "../../global/messaggioLabels";
import { LOADING, LOADING_BLOCKING } from "../../global/statusLabels";
import { resetMessaggioStateAction, setMessaggioAction } from "../messaggio/actions";
import { checkScreeningMXLActionSuccess } from "./actions";
import { CHECK_SCREENING_MX } from "./actionsType";
import { put, takeEvery, all } from "redux-saga/effects";

function* checkScreeningMXWorker() {
    yield put(checkScreeningMXLActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield apiAriannaTS.get('/api/patient/check/MX', { headers: generateHeadersCfTns() });
        } else {
            response = yield apiAriannaGW.get('/patient/check/MX');

        }

        yield put(checkScreeningMXLActionSuccess({ value: response?.data, status: response?.status }))
        yield put(resetMessaggioStateAction())


    } catch (error) {
        let bodyError;
        let condition;
        //TAPPULLO PER PROBLEMA JSON NEL GATEWAY
        if (sessionStorage.CFTNS) {
            bodyError = error?.response?.data
            condition = bodyError?.params[0] === "505"
        }

        else {
            bodyError = JSON.parse(error?.response?.data?.dettaglio?.slice(7)?.slice(0, -1))
            condition = bodyError?.params[0] === "505"
        }
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error?.response?.status === 400 && condition) {
            yield put(setMessaggioAction({ status: ERRORE_CHECK_SCREENING, value: { titolo: bodyError?.message } }))
        } else if (error?.response?.status === 400) {
            yield put(resetMessaggioStateAction())
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(checkScreeningMXLActionSuccess({ value: bodyError, status: error?.response?.status }))

    }
}

function* checkScreeningMXWatcher() {
    yield takeEvery(CHECK_SCREENING_MX, checkScreeningMXWorker);
}

export function* screeningMammograficoWatchers() {
    yield all([
        checkScreeningMXWatcher(),
    ]);
}